module.exports = __webpack_public_path__ + "img/Snipaste2.9c9ae144.png";